import { useDataChange } from 'Simple/Data.js'
import View from './view.js'

export default function Logic(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'question',
  })

  let onChooseAddress = ({ street, city, state, zip }) => {
    change(next => {
      next.answer.street = street
      next.answer.city = city
      next.answer.state = state
      next.answer.zip = zip
    })
  }

  return <View {...props} onChooseAddress={onChooseAddress} />
}
